import { motion } from "framer-motion";
import { benefits } from "@/data/products";
import { BENEFITS_IMAGE as bgImage } from "@/lib/preloadImages";

export const Benefits = () => {
  return (
    <section id="benefits" data-testid="benefits-section" className="bg-[#1d231e] text-[#f4f1eb] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <span className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-[#ff8a3d]">
              <span className="h-px w-8 bg-[#c79a3e]" />
              The Manifesto
            </span>
            <h2 className="font-serif-display text-5xl sm:text-6xl tracking-tight mt-3 leading-[0.95]">
              Why we exist
            </h2>
            <p className="mt-6 max-w-sm text-[#f4f1eb]/70 leading-relaxed">
              Most supplements are guesswork in a bottle. We built Alpha Omega
              Vitality on the opposite premise: clinical rigor, radical
              transparency, and ingredients nature already perfected.
            </p>
            <div className="mt-10 overflow-hidden rounded-3xl border border-white/10">
              <img
                src={bgImage}
                alt="Premium supplements and botanicals sourced in the USA"
                className="h-64 w-full object-cover"
                loading="lazy"
              />
            </div>
            <div
              data-testid="usa-sourced-badge"
              className="mt-6 flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3.5"
            >
              <img
                src="/usa-flag.webp"
                alt="United States flag"
                className="h-7 w-11 shrink-0 rounded-[3px] object-cover shadow-md ring-1 ring-black/5"
              />
              <span className="text-sm leading-snug text-[#f4f1eb]/85">
                Every product is <strong className="font-medium text-white">sourced and shipped in the United States</strong>.
              </span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex flex-col">
            {benefits.map((b, i) => (
              <motion.div
                key={b.n}
                data-testid={`benefit-${b.n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-[auto_1fr] gap-6 sm:gap-10 border-t border-white/10 py-8 first:border-t-0 first:pt-0"
              >
                <span className="font-serif-display text-6xl sm:text-7xl leading-none text-[#e85d04]">
                  {b.n}
                </span>
                <div>
                  <h3 className="font-serif-display text-2xl sm:text-3xl tracking-tight">
                    {b.title}
                  </h3>
                  <p className="mt-3 text-[#f4f1eb]/70 leading-relaxed max-w-lg">
                    {b.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
